import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import React from "react";
import Card from "../../Components/Card";
import { decimalFormatter } from "../../Utils/Formatter";
import LoadingBar from "../../Components/Loaders/LoadingBar";

const UserStat = ({ icon, total, partial, label, partialLabel, loading }) => {
  return (
    <Card>
      <dt>
        <div className="absolute rounded-md bg-primary p-3">{icon}</div>
        <p className="ml-16 truncate text-sm font-medium text-gray-500">
          {label}
        </p>
      </dt>
      <dd className="ml-16 flex items-baseline ">
        {loading ? (
          <div className="mt-0.5">
            <LoadingBar height="h-6" width="w-12" />
          </div>
        ) : (
          <p className="text-xl font-semibold text-gray-900">
            {decimalFormatter.format(partial)}{" "}
            {partialLabel && " " + partialLabel}
          </p>
        )}
        {total && !loading ? (
          <p
            className={` ${
              partial > total ? "text-green-600" : "text-red-600"
            }   ml-2 flex items-baseline text-sm font-semibold whitespace-nowrap`}
          >
            {partial > total ? (
              <ArrowUpIcon
                className="h-5 w-5 flex-shrink-0 self-center text-green-500"
                aria-hidden="true"
              />
            ) : (
              <ArrowDownIcon
                className="h-5 w-5 flex-shrink-0 self-center text-red-500"
                aria-hidden="true"
              />
            )}

            <span className="sr-only">
              {partial > total ? "Increased" : "Decreased"} by
            </span>
            {parseInt(decimalFormatter.format((partial / total - 1) * 100)) +
              " %"}
          </p>
        ) : (
          <></>
        )}
      </dd>
    </Card>
  );
};

export default UserStat;
